import { render, staticRenderFns } from "./ffbanner.vue?vue&type=template&id=48068992&"
import script from "./ffbanner.vue?vue&type=script&lang=js&"
export * from "./ffbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports